module.exports = __webpack_public_path__ + "static/media/table-minus.277062d9.png";